import axios from "axios";
import { message } from "antd";
import { lastRequestUrl, lastRequestCount } from "../redux/slices/requestSlice";
import { signOut } from "../redux/slices/userSlice";
import { getSafe } from "./functions";

export default {
  setup: (store) => {
    axios.interceptors.request.use(
      (request) => {
        if (store.getState().request.lastRequestUrl === request.url) {
          store.dispatch(lastRequestCount(1));
        } else {
          store.dispatch(lastRequestCount(0));
          store.dispatch(lastRequestUrl(request.url));
        }
        return request;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        let messageType = "error";

        if (
          getSafe(() => error.response.status) === 401 &&
          getSafe(() => error.response.data.type) === "session_expired"
        ) {
          store.dispatch(signOut());
          messageType = "warning";
        }

        message[messageType](
          getSafe(
            () => error.response.data.message,
            "An unknown error occured, please try again soon."
          )
        );

        return Promise.reject(error);
      }
    );
  },
};
